<!-- apps/frontend/src/components/flow/nodes/ToolOutputNode.vue -->
<template>
  <div
    :class="['bg-gray-700 border-2 rounded-lg shadow-lg w-64',
             selected ? 'border-emerald-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <Handle type="target" :position="Position.Left" />

    <!-- Header -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-emerald-400">output</span>
        <strong class="text-white">{{ $t('flowEditor.palette.toolOutput') }}</strong>
      </div>
      <ValidationMarker :error="data.__validationError" />
    </div>

    <!-- Body -->
    <div class="p-3">
      <p class="text-gray-400 text-xs mb-1">{{ $t('flowEditor.nodes.common.returnValueLabel') }}</p>
      <p class="text-white text-sm font-mono truncate">
        {{ data.value || $t('flowEditor.nodes.common.emptyReturnValue') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import ValidationMarker from './ValidationMarker.vue';

defineProps({
  data:     { type: Object,  required: true },
  selected: { type: Boolean, default: false },
});
</script>
